"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _InventoryS3BucketDestination_1 = require("./_InventoryS3BucketDestination");
exports._InventoryDestination = {
    type: "structure",
    required: ["S3BucketDestination"],
    members: {
        S3BucketDestination: {
            shape: _InventoryS3BucketDestination_1._InventoryS3BucketDestination
        }
    }
};
//# sourceMappingURL=_InventoryDestination.js.map